const axios = require('axios');

module.exports = async function (req, res, next) {
    if (req.url === '/sitemap.xml') {
        try {
            const baseUrl = process.env.API_BASE_URL;
            const token = process.env.TOKEN;
            const response = await axios.get(`${baseUrl}/general/sitemap-file`, {
                responseType: 'arraybuffer',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'token': token,
                },
            });
            res.setHeader('Content-Type', 'application/xml');
            res.end(response.data);
        } catch (error) {
            res.statusCode = 502;
            console.log(error)
            res.end('Bad Gateway: Unable to fetch sitemap');
        }
    } else {
        next();
    }
};
